import { tns } from 'tiny-slider/src/tiny-slider'


export default () => {

	const els = [...document.querySelectorAll('#programmes')]
	els.map(el => {

		const carouselEl = el.querySelector('.programme-carousel')
		if (!carouselEl) return null

		const programmeControls = el.querySelector('.carousel__controls')



		// remove classes for setting pagewidth before carousel inits
		//carouselEl.classList.remove('grid')
		//carouselEl.classList.remove('page-width')

		return tns({
			container: carouselEl,
			items: 1,
			controls : true,
			controlsPosition: 'bottom',
			controlsContainer: programmeControls,
			nav: false,
			navPosition: 'top',
			touch: true,
			mouseDrag: true,
			loop: false,
			slideBy: 1,
			responsive : {
				450 : { items : 1 },
				860 : { items : 2 },
				1150 : { items : 3 },
			}
		})
	})
}




